import { render, staticRenderFns } from "./tetapkanpenyeliaprosesanoperasi.vue?vue&type=template&id=a1c3e3de"
import script from "./tetapkanpenyeliaprosesanoperasi.vue?vue&type=script&lang=js"
export * from "./tetapkanpenyeliaprosesanoperasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports